export const FIXED_ASSET_CATEGORIES = [
  "Land",
  "Flat",
  "Apartment",
  "House",
  "Commercial Property",
  "Others"
];

// Every multi-row umbrella lives here plus the few genuinely standalone
// instruments; the old per-scheme/per-bank categories were retired after
// migrating into umbrellas ("Savings Account" now IS the accounts umbrella).
export const LIQUID_ASSET_CATEGORIES = [
  "Savings Account",
  "US Stocks",
  "Mutual Funds",
  "Gold",
  "Crypto",
  "Govt Schemes",
  "Bonds",
  "Loans",
  "Fixed Deposit",
  "Recurring Deposit",
  "Others"
];

export const PERSONAL_ITEM_CATEGORIES = [
  "Electronics",
  "Gadgets",
  "Jewellery",
  "Vehicles",
  "Furniture",
  "Others"
];

// Legacy - keeping for backward compatibility
export const ASSET_CATEGORIES = [
  ...FIXED_ASSET_CATEGORIES,
  ...LIQUID_ASSET_CATEGORIES,
  ...PERSONAL_ITEM_CATEGORIES
].filter((v, i, a) => a.indexOf(v) === i); // Remove duplicates

export const LIABILITY_CATEGORIES = [
  "Personal Loan", "Home Loan", "Car Loan", "Credit Card", "Others"
];

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
};

export const convertToINR = (amount, currency, exchangeRates) => {
  if (!amount || isNaN(amount)) return 0;
  if (!exchangeRates || !exchangeRates[currency]) return 0;
  return amount * exchangeRates[currency];
};

// Vaulzo: fallback ₹ per $ when live FX is unavailable (matches design reference).
export const USD_INR_FALLBACK = 95.3;

export const getUsdRate = (exchangeRates) =>
  exchangeRates && exchangeRates.USD ? exchangeRates.USD : USD_INR_FALLBACK;

// "$93,782 USD" style used under the hero.
export const formatUSD = (value, { decimals = 0, suffix = " USD" } = {}) => {
  const n = Number(value) || 0;
  return (
    "$" +
    n.toLocaleString("en-US", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }) +
    suffix
  );
};
